/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateApiKeyDto { 
    userId?: number;
    username?: string;
    apiKey?: string;
    createdOn?: Date;
    expiresOn?: Date;
    updatedOn?: Date;
    deleted?: boolean;
}